<template>
    <div class="nwesbox" v-if="Object.keys(this.form).length">
        <div class="head-box"><navBar :isNav2="true"></navBar></div>
        <div class="nwesbox-sec1 ptb100">
            <div class="nwesbox1_img">
                <div :class="new1index == index ? 'img active' : 'img'" v-for="(item, index) in form.news1cont" :key="index">
                    <img :src="item.src" alt="" />
                </div>
            </div>
            <div class="container1">
                <div class="nwesbox1_cont swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in form.news1cont" :key="index">
                            <itemAdd :list="form.news1cont" :itemIndex="index" :ObjectKey="'path'"></itemAdd>
                            <div class="item" @click="gotoDetails(item.path)">
                                <div class="img base_img">
                                    <img v-img="{ form: item, key: 'src' }" :src="item.src" alt="" />
                                </div>
                                <div class="gt">
                                    <div class="tit font30" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                    <div class="text" v-edit="{ form: item, key: 'text' }">{{ item.text }}</div>
                                    <div class="time1" v-edit="{ form: item, key: 'time' }">{{ item.time }}</div>
                                    <div class="but">
                                        <div class="nwesbox_but">
                                            <span>查看更多</span>
                                            <!-- <i><img src="../../assets/images/xiangyousvg.svg" /></i> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nwesbox1-prev swiper-button-prev swiper-button-white"></div>
                <div class="nwesbox1-next swiper-button-next swiper-button-white"></div>
                <div class="nwesbox1-page swiper-pagination"></div>
            </div>
        </div>
        <!-- 面包屑 -->
        <div class="breadbox">
            <div class="container1">
                <div class="f_cont wow fadeInUp">
                    <router-link to="/">首页</router-link>
                    <span>&gt;</span>
                    <a href="javascript:;">资讯中心</a>
                </div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="nwesbox-sec2 ptb120">
            <div class="container1">
                <div class="cont">
                    <template v-for="(item, index) in form.new2data">
                        <div :title="item.title" class="item wow fadeInUp" @click="gotoDetails('newsinfo/' + item.id)">
                            <div class="img base_img">
                                <img :src="item.coverImageUrl" :alt="item.coverImageUrl" />
                            </div>
                            <div class="gt">
                                <div class="font">
                                    <div class="tit font24">{{ item.title }}</div>
                                    <div class="text">{{ item.contentAbstract }}</div>
                                    <div class="time1">{{ item.time }}</div>
                                    <div class="label" v-if="typeObj[item.refColumnId]">
                                        <div class="li">{{ typeObj[item.refColumnId] }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- size每页显示条目个 count总页数 page当前页 current-change页数切换时触发 -->
                <el-pagination
                    :page-size="dataForm.size"
                    layout="prev, pager, next"
                    :current-page="dataForm.current"
                    :total="total || 0"
                    @current-change="Curpage"
                    class="basepage wow fadeInUp"
                ></el-pagination>
            </div>
        </div>
        <router-view></router-view>
        <submit-form :form="form" :refComponentId="165" :id="140"></submit-form>
    </div>
</template>

<script>
import Swiper from 'swiper'; //  ES6 导入swiper js文件
import 'swiper/dist/css/swiper.min.css'; // ES6 导入swiper css文件
import navBar from '../../components/navBar.vue';
import { initWow } from '@/utils/wow';
import { newList, getByBusinessId } from '../../api/index';
import submitForm from '../../components/submit-form.vue';
import { pageQuery } from '../../api/index';
import itemAdd from '../../components/item-add.vue';
export default {
    components: {
        navBar,
        submitForm,
        itemAdd
    },
    data() {
        return {
            typeObj: {},
            new1index: 0,
            total: 0,
            //搜索内容
            form: {
                news1cont: [
                    // {
                    //   src: require('../../assets/images/shueiw1.jpg'),
                    //   title: '数位大数据荣获财联社投资峰会“2022...',
                    //   text: '日前，2022年第五届财联社投资峰会在上海圆满举办，数位大数据荣获“年度最具投资潜力奖”。数位大数据创始人兼CEO黄兴丽出席峰会并领奖。财联社立足国家金融中心上海...',
                    //   time: "2022-03-24",
                    //   path:'/'
                    // },
                    // {
                    //   src: require('../../assets/images/shueiw1.jpg'),
                    //   title: '2数位大数据荣获财联社投资峰会“2022...',
                    //   text: '日前，2022年第五届财联社投资峰会在上海圆满举办，数位大数据荣获“年度最具投资潜力奖”。数位大数据创始人兼CEO黄兴丽出席峰会并领奖。财联社立足国家金融中心上海...',
                    //   time: "2022-03-24",
                    //   path:'/'
                    // },
                    // {
                    //   src: require('../../assets/images/shueiw1.jpg'),
                    //   title: '3数位大数据荣获财联社投资峰会“2022...',
                    //   text: '日前，2022年第五届财联社投资峰会在上海圆满举办，数位大数据荣获“年度最具投资潜力奖”。数位大数据创始人兼CEO黄兴丽出席峰会并领奖。财联社立足国家金融中心上海...',
                    //   time: "2022-03-24",
                    //   path:'/'
                    // }
                ],
                new2data: []
            },
            dataForm: {
                current: 1,
                size: 5
            }
        };
    },
    mounted: function() {
        pageQuery({ componentId: '165', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
        });
        this.getTypeList();
        this.getNewsList();
    },
    methods: {
        Curpage(val) {
            this.dataForm.current = val;
            this.getNewsList();
        },
        getNewsList() {
            newList(this.dataForm).then(res => {
                this.form.new2data = res.data.data;
                this.total = res.data.total;
                this.$nextTick(() => {
                    initWow();
                });
                /* 新闻轮播 */
                var _thas = this;
                var nwesbox1cont = new Swiper('.nwesbox1_cont', {
                    navigation: {
                        nextEl: '.nwesbox1-next',
                        prevEl: '.nwesbox1-prev'
                    },
                    observer: true, //开启动态检查器，监测swiper和slide
                    observeParents: true, //监测Swiper 的祖/父元素
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    pagination: {
                        el: '.nwesbox1-page',
                        clickable: true
                    },
                    autoplay: {
                        delay: 4000,
                        stopOnLastSlide: false,
                        disableOnInteraction: true
                    },
                    on: {
                        slideChangeTransitionStart: function() {
                            // alert(this.activeIndex);
                            _thas.new1index = this.activeIndex;
                        }
                    }
                });
                /* 内容 */
                var nwesboxswip = new Swiper('.nwesbox_swip', {
                    observer: true, //开启动态检查器，监测swiper和slide
                    observeParents: true, //监测Swiper 的祖/父元素
                    slidesPerView: 'auto',
                    watchOverflow: true //因为仅有1个slide，swiper无效
                });
            });
        },
        getTypeList() {
            let data = { businessId: 1, pagePath: '/news' };
            getByBusinessId(data).then(res => {
                res.data.map(item => {
                    this.typeObj[item.id] = item.name;
                });
                console.log(this.typeObj);
            });
        },
        gotoDetails(path) {
            if (!this.$store.state.token) {
                this.$router.push(path);
            }
        }
    }
};
</script>

<style scoped lang="less">
::v-deep .navBar-box {
    z-index: 100;
    background: #fff;
    box-shadow: 0 4px 40px rgba(50, 51, 51, 0.06);
    .navbar .nav-link {
        color: #333333;
    }
    .navbar .right-box .el-dropdown-link,
    .navbar {
        color: #333;
    }
    .navbar .nav-link .arrow {
        background-image: url(../../assets/images/arrow-down2.svg);
    }
    .navbar .navbar-toggler .icon-caidan {
        color: #333;
    }
    .navbar .navbar-collapse {
        @media @max-sm {
            position: absolute;
            top: 77px;
            left: 0;
            width: 100%;
            padding: 0 20px;
            background: #fff;
            overflow: hidden;
        }
    }
    .left-box {
        @media @max-sm {
            display: flex;
            align-items: center;
            height: 60px;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
